import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { LangSwitcherService } from './lang-switcher.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private translate: TranslateService, private langSwitcherService: LangSwitcherService) {
    const lang = this.langSwitcherService.getActiveLangFromStorage();
    this.translate.setDefaultLang(lang);
  }

  title = 'StarBusiness';
}
